export enum DIALOG_TYPES {
  EDIT_NETWORK,
  DELETE_NETWORK,
  CREATE_SUBNET,
  EDIT_SUBNET,
  DELETE_SUBNET,
  EDIT_PORT,
  DELETE_PORT,
  CREATE_PORT,
  ENABLE_PORT,
  DISABLE_PORT
}

export enum TABS {
  SUBNETS,
  PORTS
}
